import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useAppContext } from "../../../../../../context/AppContext";
import { decodeId, encodeId } from "../../../../../../utils/hash";
import EADetailsCard from "../../components/EADetailsCard";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import { LicenceData } from "../../../../network/api/LicenceData";
import Toast from "../../../../../../components/Toast";
import Alerts from "../../../../../../components/Alerts";


export default function GenerateKey() {
    const navigate = useNavigate();
    const { setPageTitle, appData, setPageUserID } = useAppContext();
    const { id: eaID } = useParams();
    const eaId = decodeId(eaID);

    const [expert, setExpert] = useState(null);

    const [pageLoading, setPageLoading] = useState(false);
    const [pageErrorMessage, setPageErrorMessage] = useState(null);
    const [isFormEdited, setIsFormEdited] = useState(false);

    const [toastConfig, setToastConfig] = useState({ visible: false, message: "", type: "primary" });

    const [licenceFormData, setLicenceFormData] = useState({
        ea: eaId,
        plan: "3500",
        type: appData?.business_models[0] || null
    });
    const handleLicenceFormChange = (e) => {
        const { name, value } = e.target;
        setLicenceFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setIsFormEdited(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setPageLoading(true);
        setPageErrorMessage(null);
        setIsFormEdited(false);
        try {
            const response = await LicenceData({ method: "POST", formData: licenceFormData });
            if (response.status === "success") {
                setToastConfig({ visible: true, message: "Key generated successfully!", type: "success" });
                setPageErrorMessage({ code: 200, message: response.message, sts: "success" });

                setTimeout(() => {
                    navigate(`/eas/licence/${encodeId(response.data.id)}`);
                }, 1000);

            } else {
                setPageErrorMessage({ code: response.code, message: response.message, sts: "danger" });
                setToastConfig({ visible: true, message: response.message, type: "danger" });
            }

        } catch (err) {
            setPageErrorMessage({ code: 500, message: err.message || "Failed to load profile.", sts: "danger" });
            setToastConfig({ visible: true, message: "Failed to generate key", type: "danger" });
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        setPageUserID(expert?.owner);
    }, [expert, setPageUserID]);

    useEffect(() => {
        setPageTitle("Generate Key");
    }, [setPageTitle]);
    return (
        <UserPageLayout>
            <Toast message={toastConfig.message}
                type={toastConfig.type}
                visible={toastConfig.visible}
                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
            />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row page-titles">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item  "><Link to={`/eas/${encodeId(eaId)}`}>EA Details</Link></li>
                            <li className="breadcrumb-item  active"><span>Generate key</span></li>
                        </ol>
                    </div>

                    <div className="row">
                        <div className="col-xl-8">
                            <div className="card shadow border-0">
                                <div className="card-body">
                                    <div className="mb-4">
                                        <h4 className="card-title">Generate License Key</h4>
                                        <p className="card-text text-muted">Please enter the details of the user you want to authorize.</p>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        {!pageLoading && pageErrorMessage && !isFormEdited ?
                                            <Alerts type={pageErrorMessage.sts === "success" ? "success" : "danger"} message={pageErrorMessage.message} />
                                            : <></>}
                                        <div className="mb-3">
                                            <label htmlFor="fullname" className="form-label">Full Name</label>
                                            <input type="text" className="form-control" name="name" placeholder="Enter full name" required={true} onChange={handleLicenceFormChange} />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">Email (Optional)</label>
                                            <input type="email" className="form-control" name="email" placeholder="Enter email address" onChange={handleLicenceFormChange} />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="plan" className="form-label">Plan</label>
                                            <select value={3500} className="form-select" name="plan" required={true} onChange={handleLicenceFormChange}>
                                                <option value="30">30 days</option>
                                                <option value="90">3 months</option>
                                                <option value="180">6 months</option>
                                                <option value="365">1 year</option>
                                                <option value="3500" >Lifetime</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="type" className="form-label">Type</label>
                                            <select
                                                className="form-select"
                                                name="type"
                                                value={licenceFormData.type}
                                                onChange={handleLicenceFormChange}
                                            >
                                                {appData?.business_models?.map((model, index) => (
                                                    <option key={index} value={model}>{model}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <button type="submit" className="btn btn-primary btn-md btn-block" disabled={pageLoading} >{pageLoading ? <ButtonLoader /> : "Generate Key"}</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-12 col-sm-12">
                            <EADetailsCard eaId={eaId} setExpert={setExpert} expert={expert} showImage={true} showFooterStats={false} showGButton={false} />
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}